import React from "react";

import { Navbar } from "../../../components";
import { Han } from "./Han";

const HanProject = () => {
  return (
    <div className="app">
      <Navbar />
      <Han />
    </div>
  );
};

export default HanProject;
